// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"59a4c9b6","139":"8f3f354c","390":"5175788f","544":"703342f9","547":"d71616a9","906":"b9b83ed6","928":"c8829475","951":"67a3597a"}[chunkId] + ".chunk.js";
};